function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import { genId } from '../../helpers/generator';
import DropdownTrigger from './trigger';
import DropdownMenu from './menu';
import DropdownDivider from './divider';
import { useOnClickOutside } from '../../hooks';
import '../../helpers/polyfills/closest';
import { ContextNested } from '../../hooks/context-nested';

var Dropdown = function Dropdown(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      forceControl = _ref.forceControl,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? genId() : _ref$id,
      onClick = _ref.onClick,
      size = _ref.size,
      others = _objectWithoutProperties(_ref, ["active", "children", "className", "disabled", "forceControl", "id", "onClick", "size"]);

  var _useState = useState(active),
      _useState2 = _slicedToArray(_useState, 2),
      _active = _useState2[0],
      setActive = _useState2[1];

  var dropdownRef = useRef(null);
  var outsideClick = useOnClickOutside(dropdownRef);
  useEffect(function () {
    if (!forceControl && !outsideClick) setActive(false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outsideClick]);
  var classes = classNames('dropdown tile', className, _defineProperty({
    'is-active': forceControl ? active : _active
  }, "is-".concat(size), size));

  var toggleDropdown = function toggleDropdown(e) {
    if (disabled) return false;
    setActive(!_active); // e.target.id = id

    e.target.active = !_active;
    if (typeof onClick === 'function') onClick(e);
  };

  var _contextNested = useContext(ContextNested);

  return React.createElement(ContextNested.Provider, {
    value: {
      isNestedInParent: 'div',
      isNestedInlink: _contextNested.isNestedInlink
    }
  }, React.createElement("div", {
    ref: dropdownRef,
    className: "field"
  }, React.createElement("span", {
    className: classNames('control is-tri', {
      'is-disabled': disabled
    })
  }, React.createElement("span", _extends({
    id: id
  }, {
    className: classes
  }, others), children.map(function (child, index) {
    return React.cloneElement(child, {
      key: index,
      active: index === 0 && forceControl && _active,
      onClick: index === 0 ? function (e) {
        return forceControl ? child.props.onClick(e) : toggleDropdown(e);
      } : null
    });
  })))));
};

Dropdown.propTypes = {
  id: PropTypes.string,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  size: PropTypes.number,
  active: PropTypes.bool,
  forceControl: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};
Dropdown.Trigger = DropdownTrigger;
Dropdown.Menu = DropdownMenu;
Dropdown.Divider = DropdownDivider;
export default withModifiers(Dropdown);